export enum Role {
  ADMIN = 'admin',
  MANAGER = 'manager',
  DATA_EDITOR = 'data-editor',
  ADMIN_PLANTS = 'administrator_plants',
  ADMIN_ANIMALS = 'administrator_animals',
  BCGOV_STAFF_ANIMALS = 'bcgov_staff_animals',
  BCGOV_STAFF_PLANTS = 'bcgov_staff_plants',
  BCGOV_STAFF_BOTH = 'bcgov_staff_both',
  CONTRACTOR_MANAGER_ANIMALS = 'contractor_manager_animals',
  CONTRACTOR_MANAGER_PLANTS = 'contractor_manager_plants',
  CONTRACTOR_MANAGER_BOTH = 'contractor_manager_both',
  CONTRACTOR_STAFF_PLANTS = 'contractor_staff_plants',
  CONTRACTOR_STAFF_ANIMALS = 'contractor_staff_animals',
  CONTRACTOR_STAFF_BOTH = 'contractor_staff_both',
  INDIGENOUS_RISO_MANAGER_ANIMALS = 'indigenous_riso_manager_animals',
  INDIGENOUS_RISO_MANAGER_PLANTS = 'indigenous_riso_manager_plants',
  INDIGENOUS_RISO_MANAGER_BOTH = 'indigenous_riso_manager_both',
  INDIGENOUS_RISO_STAFF_ANIMALS = 'indigenous_riso_staff_animals',
  INDIGENOUS_RISO_STAFF_PLANTS = 'indigenous_riso_staff_plants',
  INDIGENOUS_RISO_STAFF_BOTH = 'indigenous_riso_staff_both',
  MUSSEL_INSPECTION_OFFICER = 'mussel_inspection_officer',
  MASTER_ADMINISTRATOR = 'master_administrator',
  NOT_ACTIVATED = 'not_activated'
}

export const ALL_ROLES = [
  Role.ADMIN,
  Role.MANAGER,
  Role.DATA_EDITOR,
  Role.ADMIN_ANIMALS,
  Role.ADMIN_PLANTS,
  Role.BCGOV_STAFF_ANIMALS,
  Role.BCGOV_STAFF_PLANTS,
  Role.BCGOV_STAFF_BOTH,
  Role.CONTRACTOR_MANAGER_ANIMALS,
  Role.CONTRACTOR_MANAGER_PLANTS,
  Role.CONTRACTOR_MANAGER_BOTH,
  Role.CONTRACTOR_STAFF_PLANTS,
  Role.CONTRACTOR_STAFF_ANIMALS,
  Role.CONTRACTOR_STAFF_BOTH,
  Role.INDIGENOUS_RISO_MANAGER_ANIMALS,
  Role.INDIGENOUS_RISO_MANAGER_PLANTS,
  Role.INDIGENOUS_RISO_MANAGER_BOTH,
  Role.INDIGENOUS_RISO_STAFF_ANIMALS,
  Role.INDIGENOUS_RISO_STAFF_PLANTS,
  Role.INDIGENOUS_RISO_STAFF_BOTH,
  Role.MUSSEL_INSPECTION_OFFICER,
  Role.MASTER_ADMINISTRATOR
];
